import dayjs from "dayjs";
import { useField } from "formik";
import {
  DateRangePicker,
  IFocusedInputShape,
  IDateFormat,
  Form,
} from "taltech-styleguide";
import { useState } from "react";
import { FeedbackMessage } from "./FeedbackMessage";
import { addDaysToDate } from "../../../_website/_helper.functions";

export const InputDateRange = (props: any) => {
  const [focused, setFocused] = useState<IFocusedInputShape | null>(null);
  const [fieldStart, metaStart, handlersStart] = useField("startDate");
  const [fieldEnd, metaEnd, handlersEnd] = useField("endDate");
  const comp = (
    <Form.Group className="required">
      <Form.Label>Start date - End date</Form.Label>
      <DateRangePicker
        startDate={dayjs(fieldStart?.value)}
        startDateId="startDate"
        endDate={dayjs(fieldEnd?.value)}
        endDateId="endDate"
        endDatePlaceholderText="Start date"
        focusedInput={focused}
        isOutsideRange={() => false}
        onDatesChange={(dates: {
          startDate: IDateFormat;
          endDate: IDateFormat;
        }) => {
          if (dates.startDate === null && dates.endDate === null) {
            handlersStart.setValue(addDaysToDate(new Date(Date.now()), 1));
            handlersEnd.setValue(addDaysToDate(new Date(Date.now()), 2));
            return;
          }
          handlersStart.setValue(dates.startDate);
          handlersEnd.setValue(dates.endDate);
        }}
        onFocusChange={(focus: IFocusedInputShape | null) => {
          if (focus !== focused) {
            setFocused(focus);
          }
        }}
        showClearDates
        startDatePlaceholderText="End date"
        disabled={props.disabled}
      />
      <FeedbackMessage fieldId={"startDate"}></FeedbackMessage>
      <FeedbackMessage fieldId={"endDate"}></FeedbackMessage>
    </Form.Group>
  );
  return comp;
};
